<div class="container">
  <div class="row">
    <div class="form-group w-100">
      <div class="custom-file">
        <!--id = 'customFile' if face an erro please add this id to input field-->
        <input
          type="file"
          class="custom-file-input"
          id="{{name}}"
          [multiple] = "isMultiple"
          name="image"
          (change)="fileProgress($event)"
          />
        <label class="custom-file-label lab-height" for="{{name}}">Choose file</label>
      </div>
    </div>
    @if (fileUploadProgress) {
      <div>
        Upload progress: {{ fileUploadProgress }}
      </div>
    }

    @if (previewUrl && isPreviewShow) {
      <div class="image-preview mb-3" >
        @for (url of previewUrl; track url; let i = $index) {
          <div
            style="display: inline-block" class="imageHolder">
            <a
              href="javascript:void(0);"
              (click)="remove(i)"
              class="up-img-cross"
              >
              <mat-icon>cancel</mat-icon>
            </a>
            <!--<img class="up-img" *ngIf="url.type==='video'" alt="" src="assets/images/videoIcon.png">
            <img *ngIf="url.type==='image'" [src]="url.path" height="50" class="up-img">
            <img class="abc" *ngIf="url.type==='csv'" alt="" src="assets/images/csv-file.png">
            <img class="abc" *ngIf="url.type==='word'" alt="" src="assets/images/word-file.png">
            <img class="abc" *ngIf="url.type==='pdf'" alt="" src="assets/images/pdf.png">
            <img class="abc" *ngIf="url.type==='ppt'" alt="" src="assets/images/ppt.png">-->
            @if (url.type===fileService.FILE_TYPE_IMG) {
              <mat-icon>image</mat-icon>
            }
            @if (url.type===fileService.FILE_TYPE_PDF) {
              <mat-icon>picture_as_pdf</mat-icon>
            }
            @if (isShowFileName) {
              <span style="padding-left: 10px;">{{orignalFileName}}</span>
            }
            @if (url.type!=='image'
              && url.type!=='csv'
              && url.type!=='word'
              && url.type!=='pdf'
              && url.type!=='ppt'
              && url.type!=='video') {
              <span
              > {{url.type}} </span>
            }
          </div>
        }
      </div>
    }

    @if (uploadedFilePath) {
      <div class="mb-3">
        {{uploadedFilePath}}
      </div>
    }
  </div>
</div>
